import { Sun, Moon, Monitor } from "lucide-react";
import { useTheme } from "../../contexts/ThemeContext";

const OPTIONS = [
    { id: "light", label: "Light", icon: Sun },
    { id: "dark", label: "Dark", icon: Moon },
    { id: "system", label: "System", icon: Monitor },
];

export default function AppearanceCard() {
    const { theme, setTheme } = useTheme();

    return (
        <div className="rounded-3xl border border-stone-200/80 dark:border-stone-800 bg-white/70 dark:bg-[#242322]/70 p-6" data-testid="settings-appearance">
            <div className="text-[11px] tracking-[0.2em] uppercase font-bold text-stone-400">Appearance</div>
            <div className="mt-4 grid grid-cols-3 gap-2">
                {OPTIONS.map(({ id, label, icon: Icon }) => (
                    <button
                        key={id}
                        onClick={() => setTheme(id)}
                        data-testid={`theme-${id}`}
                        className={`flex flex-col items-center gap-1.5 py-4 rounded-2xl border transition-colors
                            ${theme === id
                                ? "border-terracotta bg-terracotta/10 text-terracotta"
                                : "border-stone-200 dark:border-stone-700 hover:border-stone-400 text-stone-600 dark:text-stone-300"}`}
                    >
                        <Icon size={18} strokeWidth={1.5} />
                        <span className="text-xs font-medium">{label}</span>
                    </button>
                ))}
            </div>
        </div>
    );
}
